import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import'./assets/styles.css'
import textsPlugin from './plugins/texts'
import vertalingMixin from '@/mixins/vertaling'
import calendarLocaleMixin from '@/mixins/calenderLocale'
import datumConversie from "@/mixins/datumConversie"
import controleVlekken from "@/mixins/controleVlekken"
import versieInhoud from "@/mixins/versieInhoud"


Vue.config.productionTip = false

Vue.use(textsPlugin, { defaultLanguage: 'nl' })
Vue.mixin(vertalingMixin)
Vue.mixin(calendarLocaleMixin)
Vue.mixin(datumConversie)
Vue.mixin(controleVlekken)
Vue.mixin(versieInhoud)

async function bootstrapApp() {
    await store.dispatch('authModule/initAuth')
    new Vue({
        router,
        store,
        vuetify,
        render: h => h(App)
    }).$mount('#app')
}

bootstrapApp()

